import { Component, OnInit, Input } from '@angular/core';

import { AccordionModule } from 'ngx-bootstrap/accordion';

import { DropEvent } from 'ng-drag-drop';

import {ReportDataService} from '../report-data.service';
import {Report} from '../shared/report.model';
import {MappableData} from '../shared/data/MappableData';
import {CostHourDefinitionsMap} from '../shared/data/CostHourDefinitionsMap';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { environment } from '../../environments/environment.dev';

@Component({
  selector: 'app-mapping',
  templateUrl: './mapping.component.html',
  styleUrls: ['./mapping.component.css']
})
export class MappingComponent implements OnInit {
  @Input() mapTo: MappableData;
  fileData = [];

  constructor(private reportService: ReportDataService, private loadingBar: SlimLoadingBarService) {
    this.reportService.getRawFileData().subscribe(value => this.fileData = value);
  }

  ngOnInit() {
    console.log('mapping init');
  }

  onMap(e: DropEvent, target) {
    this.mapTo.onMap(e, target);
  }

  loadCSV(event) {
    this.loadingBar.start();
    this.reportService.parseCSV(event).then((data) => {
      this.loadingBar.complete();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/mapping/mapping.component.ts